import { Injectable } from "@angular/core";
import { ColumnConfig, ObjectUtils } from "@bmc-ux/adapt-table";
import * as XLSX from 'xlsx';


@Injectable({
    providedIn: 'root'
  })
export class TableExportService {
    private EXCEL_FORMAT = '.xlsx';
    private CSV_FORMAT = '.csv';

    public handleExportExcel(visibleColumns: ColumnConfig[], records, fileName: string): void {
        const sheets = {};
      
        const workBook: XLSX.WorkBook = XLSX.utils.book_new(); 
        let worksheet: XLSX.WorkSheet = {};
    
        const dataToWrite = [];
        records.forEach((record): void => {
          const row = {};
          for (let i = 0; i < visibleColumns.length; i++) {
            const column = visibleColumns[i];
            const header: string = column.header || column.field
            if (column.exportable !== false && column.field) {
              let cellData = ObjectUtils.resolveFieldData(record, column.field);
              row[header] = cellData;
            }
          }
          dataToWrite.push(row);
        });
    
        worksheet = XLSX.utils.json_to_sheet(dataToWrite);
        XLSX.utils.book_append_sheet(workBook, worksheet, fileName); 
        XLSX.writeFile(workBook, fileName + this.EXCEL_FORMAT); 
      }
    
      public handleExportCSV(visibleColumns: ColumnConfig[], records, fileName: string): void {
        const csvSeparator = ',';
        let csvContent = '';

        // headers
        visibleColumns.forEach((column: ColumnConfig, index: number): void => {
          if (column.exportable !== false && column.field) {
            csvContent += '"' + (column.header || column.field) + '"';
    
            if (index < (visibleColumns.length - 1)) {
              csvContent += csvSeparator;
            }
          }
        });
    
        // body
        records.forEach((record): void => {
          csvContent += '\n';
    
          for (let i = 0; i < visibleColumns.length; i++) {
            const column = visibleColumns[i];
    
            if (column.exportable !== false && column.field) {
              let cellData = ObjectUtils.resolveFieldData(record, column.field);
    
              cellData = cellData != null ? String(cellData).replace(/"/g, '""') : '';
    
              csvContent += '"' + cellData + '"';
    
              if (i < (visibleColumns.length - 1)) {
                csvContent += csvSeparator;
              }
            }
          }
        });


    // creating and downloading CSV file
    const blob = new Blob([csvContent], {
        type: 'text/csv;charset=utf-8;'
      });
      const link = document.createElement('a');
  
      link.style.display = 'none';
      link.download = fileName + this.CSV_FORMAT;
      document.body.appendChild(link);
  
      link.setAttribute('href', URL.createObjectURL(blob));
      link.setAttribute('table', 'document' + this.CSV_FORMAT);
  
      link.click();
      document.body.removeChild(link);
    }
}